var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisclosures = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4078A5",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.086 12.163h24.828M11.068 16.163h19.864M11.038 24.163h10.924",
    style: {
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 28.163h26v8H11z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.082 20.163h23.836",
    style: {
      strokeLinecap: "round"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisclosures);
export default ForwardRef;